import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-gantt',
  templateUrl: './gantt.component.html',
  styleUrls: ['./gantt.component.scss']
})
export class GanttComponent implements OnInit {

    @Input() title;
    @Input() headers;
    @Input() data;
    @Input() dateType;
    expand: boolean;

  constructor() { }

  ngOnInit() {
  }

  public toggleExpand(e) {
      this.expand = !this.expand;
  }
}
